export default __webpack_public_path__ + "atomic/_patterns/02-molecules/sub-navigation/_sub-navigation.twig";